// Marker attribute placed on selectable data cells (see Cell.tsx). The value
// is a per-table scope id (from useId()) that identifies which table owns the
// cell. A mousedown whose target's closest selectable ancestor carries a
// different scope id (or none) is treated as "outside this table's cells" and
// clears that table's selection.
export const CELL_SELECTABLE_ATTRIBUTE = 'data-fdt-cell-selectable';
export const CELL_SELECTED_ATTRIBUTE = 'data-fdt-cell-selected';

// Cells (or content within them) marked with this attribute opt out of
// plain-click cell selection — a plain (unmodified) mousedown originating
// there neither starts a selection nor suppresses the default, so the
// element's own click handler (e.g. edit-on-click, expand-row) wins.
// Modifier-clicks (Shift, Cmd/Ctrl) and fill-handle drags still proceed
// normally, so ignored elements remain range-selectable.
export const CELL_SELECTION_IGNORE_PLAIN_CLICK_ATTRIBUTE = 'data-fdt-cell-selection-ignore';
export const FILL_HANDLE_ATTRIBUTE = 'data-fdt-fill-handle';

// Which outer edges of the selection region this cell sits on. An empty string
// means the cell is interior (no edges). null means not selected at all.
// Values are substrings of "trbl" (top/right/bottom/left).
export const CELL_EDGES_ATTRIBUTE = 'data-fdt-cell-edges';

// Marker attribute on the floating cell-selection action menu. The menu is
// portaled outside the selectable cells, so the outside-click handler that
// clears the selection must treat a mousedown inside it as "inside" (otherwise
// clicking an action would clear the selection before the action runs).
export const CELL_ACTION_MENU_ATTRIBUTE = 'data-fdt-cell-action-menu';